// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../font/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../font/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../font/CenturyGothic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
.container_form {
  position: relative;
  padding: 75px 30px;
}
@media screen and (max-width: 480px) {
  .container_form {
    padding: 40px 10px;
  }
}
.container_form fieldset {
  border: none;
}
@media screen and (max-width: 991px) {
  .container_form fieldset {
    max-width: 720px;
    margin: 0 auto;
  }
}
.container_form .data {
  display: flex;
  flex-direction: row;
}
@media screen and (max-width: 991px) {
  .container_form .data {
    flex-direction: column;
  }
}
.container_form .data .box {
  width: 100%;
}
.container_form .data .box .name,
.container_form .data .box .phone {
  width: 100%;
  height: 50px;
  font-family: "Roboto-Light";
  font-size: 0.9em;
  font-weight: 400;
  padding: 9px 25px;
  text-transform: uppercase;
  text-align: center;
  color: rgb(49, 49, 49);
  border: 1px solid rgb(217, 217, 215);
  border-radius: 10px;
  background-color: rgb(255, 255, 255);
  box-sizing: border-box;
}
.container_form .data .box .name {
  margin-right: 5px;
}
@media screen and (max-width: 991px) {
  .container_form .data .box .name {
    width: 100%;
    margin-left: 0;
  }
}
.container_form .data .box .phone {
  margin-left: 5px;
}
@media screen and (max-width: 991px) {
  .container_form .data .box .phone {
    width: 100%;
    margin-left: 0;
  }
}
.container_form .data .box .normal {
  border: 1px solid rgb(190, 190, 190);
}
.container_form .data .box .error {
  border: 1px solid rgb(255, 0, 0);
}
.container_form .text_box {
  display: block;
}
@media screen and (max-width: 991px) {
  .container_form .text_box {
    width: 100%;
  }
}
.container_form .text_box .message {
  resize: inherit;
  display: block;
  width: 100%;
  height: auto;
  background-color: rgb(255, 255, 255);
  color: #313131;
  border: 1px solid rgb(217, 217, 215);
  text-align: center;
  font-family: "Roboto-Light";
  font-size: 0.9em;
  font-weight: 400;
  text-transform: uppercase;
}
.container_form .info_label {
  display: none;
}
.container_form .info_label_contact {
  min-height: 20px;
  padding-left: 20px;
  margin-bottom: 0;
  font-family: "Roboto-Light";
  cursor: pointer;
}
.container_form .info_label_contact span {
  font-weight: 400;
}
.container_form .info_label_contact .policy-href {
  text-decoration: none;
  font-weight: 700;
  color: #323232;
  cursor: pointer;
}
.container_form .time_call {
  display: none;
}
.container_form .confirmation {
  margin: 30px 0 50px 0;
  display: flex;
  justify-content: center;
}
.container_form .confirmation .checkbox {
  max-width: 560px;
  text-align: center;
}
.container_form .confirmation .checkbox .checkbox_message {
  font-family: "Roboto-Light";
  color: rgb(255, 0, 0);
  font-size: 14px;
}
.container_form .confirmation .checkbox .normal {
  display: none;
}
.container_form .confirmation .checkbox .error {
  display: inline-block;
}
.container_form .btn_submit_form {
  display: flex;
  justify-content: center;
}
.container_form .old {
  display: none;
}

.additional fieldset {
  border: none;
}
@media screen and (max-width: 767px) {
  .additional fieldset {
    margin: 0 auto;
  }
}
.additional #order_form .data .box .name,
.additional #order_form .data .box .phone {
  width: 90%;
  padding: 10px;
  border: 1px solid #d9d9d7;
  background-color: transparent;
  color: rgb(255, 255, 255);
}
@media screen and (max-width: 767px) {
  .additional #order_form .data .box .name,
  .additional #order_form .data .box .phone {
    width: 100%;
    box-sizing: border-box;
  }
}
.additional #order_form .text_box {
  display: none;
}
.additional #order_form .time_call .title_select {
  display: block;
  text-align: center;
  color: rgb(255, 255, 255);
  font-family: "Roboto-Regular";
  font-size: 14px;
}
.additional #order_form .time_call select {
  display: block;
  margin: 0 auto;
  width: 100%;
  padding: 10px;
  border: 1px solid #d9d9d7;
  background-color: transparent;
  color: rgb(129, 129, 129);
}
@media screen and (max-width: 767px) {
  .additional #order_form .confirmation .checkbox {
    text-align: center;
  }
}
.additional #order_form .confirmation .checkbox .info_label {
  min-height: 20px;
  color: rgb(255, 255, 255);
  font-family: "Roboto-Regular";
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
}
.additional #order_form .confirmation .checkbox .info_label_contact {
  display: none;
}
.additional #order_form .btn_submit_form .control_link {
  display: flex;
  justify-content: center;
}
.additional #order_form .btn_submit_form .control_link .theme_button {
  background-color: #91b61b;
  border: 2px solid #91b61b;
  border-radius: 0;
}
.additional #order_form .btn_submit_form .control_link .theme_button:hover {
  background-color: transparent;
  color: #91b61b;
}
.additional #order_form .old {
  font-family: "Roboto-Light";
  text-align: center;
  font-size: 45px;
  color: rgb(154, 154, 154);
}`, "",{"version":3,"sources":["webpack://./styles/fonts.scss","webpack://./src/components/FormContacts/FormContacts.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,+DAAA;ACCJ;ADEA;EACI,2BAAA;EACA,+DAAA;ACAJ;ADGA;EACI,6BAAA;EACA,+DAAA;ACDJ;AATA;EACI,kBAAA;EACA,kBAAA;AAWJ;AATI;EAJJ;IAKQ,kBAAA;EAYN;AACF;AATI;EACI,YAAA;AAWR;AATQ;EAHJ;IAIQ,gBAAA;IACA,cAAA;EAYV;AACF;AATI;EACI,aAAA;EACA,mBAAA;AAWR;AATQ;EAJJ;IAKQ,sBAAA;EAYV;AACF;AAVQ;EACI,WAAA;AAYZ;AARY;;EAGI,WAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;EACA,oCAAA;EACA,sBAAA;AAShB;AANY;EACI,iBAAA;AAQhB;AANgB;EAHJ;IAIQ,WAAA;IACA,cAAA;EASlB;AACF;AALY;EACI,gBAAA;AAOhB;AALgB;EAHJ;IAIQ,WAAA;IACA,cAAA;EAQlB;AACF;AALY;EACI,oCAAA;AAOhB;AAJY;EACI,gCAAA;AAMhB;AADI;EACI,cAAA;AAGR;AADQ;EAHJ;IAIQ,WAAA;EAIV;AACF;AAFQ;EACI,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EAEA,oCAAA;EACA,cAAA;EACA,oCAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AAGZ;AAEI;EACI,aAAA;AAAR;AAGI;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,eAAA;AADR;AAGQ;EACI,gBAAA;AADZ;AAIQ;EACI,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAFZ;AAMI;EACI,aAAA;AAJR;AAOI;EACI,qBAAA;EACA,aAAA;EACA,uBAAA;AALR;AAOQ;EACI,gBAAA;EACA,kBAAA;AALZ;AAOY;EAEI,2BAAA;EACA,qBAAA;EACA,eAAA;AANhB;AASY;EACI,aAAA;AAPhB;AAUY;EACI,qBAAA;AARhB;AAaI;EACI,aAAA;EACA,uBAAA;AAXR;AAcI;EACI,aAAA;AAZR;;AAmBI;EACI,YAAA;AAhBR;AAkBQ;EAHJ;IAIQ,cAAA;EAfV;AACF;AAyBgB;;EAEI,UAAA;EAEA,aAAA;EACA,yBAAA;EACA,6BAAA;EACA,yBAAA;AAxBpB;AA0BoB;EATJ;;IAUQ,WAAA;IACA,sBAAA;EAtBtB;AACF;AA2BQ;EACI,aAAA;AAzBZ;AA8BY;EACI,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;AA5BhB;AA+BY;EACI,cAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,6BAAA;EACA,yBAAA;AA7BhB;AAqCgB;EAFJ;IAGQ,kBAAA;EAlClB;AACF;AAoCgB;EACI,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAlCpB;AAqCgB;EACI,aAAA;AAnCpB;AAyCY;EACI,aAAA;EACA,uBAAA;AAvChB;AAyCgB;EACI,yBAAA;EACA,yBAAA;EACA,gBAAA;AAvCpB;AA0CgB;EACI,6BAAA;EACA,cAAA;AAxCpB;AA6CQ;EACI,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AA3CZ","sourcesContent":["@font-face {\n    font-family: \"Roboto-Regular\"; \n    src: url(\"../font/Roboto-Regular.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Roboto-Light\"; \n    src: url(\"../font/Roboto-Light.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Century Gothic\"; \n    src: url(\"../font/CenturyGothic.ttf\") format(\"truetype\");  \n}\n\n","@import '../../../styles/fonts.scss';\n\n.container_form {\n    position: relative;\n    padding: 75px 30px;\n\n    @media screen and (max-width: 480px) {\n        padding: 40px 10px;\n    }\n\n    // .row {}\n    fieldset {\n        border: none;\n\n        @media screen and (max-width: 991px) {\n            max-width: 720px;\n            margin: 0 auto;\n        }\n    }\n\n    .data {\n        display: flex;\n        flex-direction: row;\n\n        @media screen and (max-width: 991px) {\n            flex-direction: column;\n        }\n\n        .box {\n            width: 100%;\n            // margin: 0 20px;\n            // border: 1px solid red;\n\n            .name,\n            .phone {\n                // display: block;\n                width: 100%;\n                height: 50px;\n                font-family: \"Roboto-Light\";\n                font-size: 0.9em;\n                font-weight: 400;\n                padding: 9px 25px;\n                text-transform: uppercase;\n                text-align: center;\n                color: rgb(49, 49, 49);\n                border: 1px solid rgb(217, 217, 215);\n                border-radius: 10px;\n                background-color: rgb(255, 255, 255);\n                box-sizing: border-box;\n            }\n\n            .name {\n                margin-right: 5px;\n\n                @media screen and (max-width: 991px) {\n                    width: 100%;\n                    margin-left: 0;\n                }\n\n            }\n\n            .phone {\n                margin-left: 5px;\n\n                @media screen and (max-width: 991px) {\n                    width: 100%;\n                    margin-left: 0;\n                }\n            }\n\n            .normal {\n                border: 1px solid rgb(190, 190, 190);\n            }\n\n            .error {\n                border: 1px solid rgb(255, 0, 0);\n            }\n        }\n    }\n\n    .text_box {\n        display: block;\n\n        @media screen and (max-width: 991px) {\n            width: 100%;\n        }\n\n        .message {\n            resize: inherit;\n            display: block;\n            width: 100%;\n            height: auto;\n            // padding: 1em;\n            background-color: rgb(255, 255, 255);\n            color: #313131;\n            border: 1px solid rgb(217, 217, 215);\n            text-align: center;\n            font-family: \"Roboto-Light\";\n            font-size: 0.9em;\n            font-weight: 400;\n            text-transform: uppercase;\n        }\n    }\n\n\n    .info_label {\n        display: none;\n    }\n\n    .info_label_contact {\n        min-height: 20px;\n        padding-left: 20px;\n        margin-bottom: 0;\n        font-family: \"Roboto-Light\";\n        cursor: pointer;\n\n        span {\n            font-weight: 400;\n        }\n\n        .policy-href {\n            text-decoration: none;\n            font-weight: 700;\n            color: #323232;\n            cursor: pointer;\n        }\n    }\n\n    .time_call {\n        display: none;\n    }\n\n    .confirmation {\n        margin: 30px 0 50px 0;\n        display: flex;\n        justify-content: center;\n\n        .checkbox {\n            max-width: 560px;\n            text-align: center;\n\n            .checkbox_message {\n                // display: inline-block;\n                font-family: \"Roboto-Light\";\n                color: rgb(255, 0, 0);\n                font-size: 14px;\n            }\n\n            .normal {\n                display: none;\n            }\n\n            .error {\n                display: inline-block;\n            }\n        }\n    }\n\n    .btn_submit_form {\n        display: flex;\n        justify-content: center;\n    }\n\n    .old {\n        display: none;\n    }\n}\n\n.additional {\n    // border: 2px solid magenta;\n\n    fieldset {\n        border: none;\n\n        @media screen and (max-width: 767px) {\n            margin: 0 auto;\n        }\n    }\n\n    #order_form {\n\n\n        .data {\n\n            .box {\n\n                .name,\n                .phone {\n                    width: 90%;\n                    // height: 50px;\n                    padding: 10px;\n                    border: 1px solid #d9d9d7;\n                    background-color: transparent;\n                    color: rgb(255, 255, 255);\n\n                    @media screen and (max-width: 767px) {\n                        width: 100%;\n                        box-sizing: border-box;\n                    }\n                }\n            }\n        }\n\n        .text_box {\n            display: none;\n        }\n\n        .time_call {\n\n            .title_select {\n                display: block;\n                text-align: center;\n                color: rgb(255, 255, 255);\n                font-family: \"Roboto-Regular\";\n                font-size: 14px;\n            }\n\n            select {\n                display: block;\n                margin: 0 auto;\n                width: 100%;\n                padding: 10px;\n                border: 1px solid #d9d9d7;\n                background-color: transparent;\n                color: rgb(129, 129, 129);\n                // color: rgb(255, 255, 255);\n            }\n        }\n\n        .confirmation {\n            .checkbox {\n\n                @media screen and (max-width: 767px) {\n                    text-align: center;\n                }\n\n                .info_label {\n                    min-height: 20px;\n                    color: rgb(255, 255, 255);\n                    font-family: \"Roboto-Regular\";\n                    font-size: 14px;\n                    font-weight: 400;\n                    cursor: pointer;\n                }\n\n                .info_label_contact {\n                    display: none;\n                }\n            }\n        }\n\n        .btn_submit_form {\n            .control_link {\n                display: flex;\n                justify-content: center;\n\n                .theme_button {\n                    background-color: #91b61b;\n                    border: 2px solid #91b61b;\n                    border-radius: 0;\n                }\n\n                .theme_button:hover {\n                    background-color: transparent;\n                    color: #91b61b;\n                }\n            }\n        }\n\n        .old {\n            font-family: \"Roboto-Light\";\n            text-align: center;\n            font-size: 45px;\n            color: rgb(154, 154, 154);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
